import { useState, useEffect } from 'react';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';

export const XDatePicker = ({ label, name, value, onChange, error = undefined, helperText = undefined, required = undefined, ...rest }) => {

  const [localDate, setLocalDate] = useState(value !== "" ? moment(value, "YYYY/MM/DD") : null);

  useEffect(() => {
    onChange({ target: { name, value: (localDate && localDate !== "") ? localDate.format('YYYY/MM/DD') : null } })
  }, [localDate])

  useEffect(() => {
    setLocalDate((value && value.length === 10) ? moment(value, "YYYY/MM/DD") : null)
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
      <DatePicker
        label={label}
        value={localDate}
        name={name}
        variant="standard"
        id={`date-picker-${name}`}
        onChange={(newValue) => {
          setLocalDate(newValue)
        }}
        {...rest}
        slotProps={{ textField: { variant: 'standard' } }}
        TextField={(params) => <TextField {...params} value={value} variant="standard" error={error} helperText={helperText} required={required} fullWidth />}
      />
    </LocalizationProvider>
  );
}
